import { useState } from 'react'
import { useRemoteClientDelete, useRemoteClientGet, useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

interface ManageMemberSessionProps {
  sessionId: number
}

export const ManageMemberSession = ({ sessionId }: ManageMemberSessionProps) => {
  const { getUnitId } = useLocalStorage()
  const { remoteClientGet } = useRemoteClientGet()
  const { remoteClientDelete } = useRemoteClientDelete()
  const { httpClientPost } = useRemoteClientPost()
  const { showToast } = useToast()

  const [members, setMembers] = useState<any[]>([])
  const [membersFiltred, setMembersFiltered] = useState([])

  const loadMembersAdded = () => {
    remoteClientGet(`/aulas/${sessionId}`, {
      idUnidade: getUnitId()
    })
      .then((response) => {
        setMembers(response.data.data.alunosIncritos)
        showToast('Alunos carregados com sucesso', 'success')
      })
      .catch(CatchMessageError)
  }

  const findMember = (filter: string) => {
    if (filter.length < 3) return showToast('Digite pelo menos 3 caracteres para pesquisar o aluno', 'error')
    httpClientPost(`/alunos/filtro?page=${0}&size=${1000}&order=desc&sort=id`, {
      unidadeId: getUnitId(),
      status: [1],
      nome: filter
    })
      .then((response) => {
        const membersAdded = members.map((member) => member.id)
        //console.log(response.data.data.content)
        setMembersFiltered(response.data.data.content.filter((member: any) => !membersAdded.includes(member.id)))
      })
      .catch(CatchMessageError)
  }

  const removeMember = (id: any) => {
    remoteClientDelete(`/aulas/${sessionId}/alunos`, id + `?idUnidade=${getUnitId()}`)
      .then(() => loadMembersAdded())
      .catch(CatchMessageError)
  }

  const addMember = (id: any, memberId: any) => {
    httpClientPost(`/aulas/${id}/alunos?idUnidade=${getUnitId()}`, [memberId]).then(() => loadMembersAdded())
    setMembersFiltered([])
  }

  return {
    members,
    membersFiltred,
    findMember,
    loadMembersAdded,
    removeMember,
    addMember
  }
}
